import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CustomersPage from "@/pages/CustomersPage";
import CustomerFormPage from "@/pages/CustomerFormPage";
import CustomerDetailPage from "@/pages/CustomerDetailPage";
import ExpensesPage from "@/pages/ExpensesPage";
import KanbanPage from "@/pages/KanbanPage";
import PortfolioPage from "@/pages/PortfolioPage";
import PublicPortfolioPage from "@/pages/PublicPortfolioPage";
import ProfilePage from "@/pages/ProfilePage";
import AppLayout from "@/layout/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Yükleniyor...</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function GuestOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<GuestOnly><LoginPage /></GuestOnly>} />
            <Route path="/p/:slug" element={<PublicPortfolioPage />} />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/customers" element={<Protected><CustomersPage /></Protected>} />
            <Route path="/customers/new" element={<Protected><CustomerFormPage mode="create" /></Protected>} />
            <Route path="/customers/:id" element={<Protected><CustomerDetailPage /></Protected>} />
            <Route path="/customers/:id/edit" element={<Protected><CustomerFormPage mode="edit" /></Protected>} />
            <Route path="/kanban" element={<Protected><KanbanPage /></Protected>} />
            <Route path="/expenses" element={<Protected><ExpensesPage /></Protected>} />
            <Route path="/portfolio" element={<Protected><PortfolioPage /></Protected>} />
            <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
